// src/pages/Login.jsx
// Public sign-in page. Uses api helper; shows backend error messages;
// includes link to "Create an account" (/signup).

import React, { useState } from "react";
import { apiPost, setToken } from "../lib/api";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  function onChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await apiPost("/auth/login", form);

      if (data?.token) {
        // Save JWT for API calls
        setToken(data.token);

        // Persist user payload (includes tenantId, role, etc.)
        if (data.user) {
          localStorage.setItem("user", JSON.stringify(data.user));
        }

        // TODO: no futuro podemos decidir entre /setup ou /dashboard
        // baseado em um flag (ex.: user.isSetupComplete ou estado do tenant).
        window.location.href = "/setup";
      } else {
        setError("Unexpected response from server.");
      }
    } catch (err) {
      // Tenta ler a mensagem do backend primeiro
      const resp = err?.response;
      const msg =
        resp?.data?.error ||
        resp?.data?.message ||
        err?.message ||
        "Internal server error";

      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow p-6">
        <h1 className="text-2xl font-semibold mb-1">Sign in</h1>
        <p className="text-sm text-gray-500 mb-6">
          Access your dashboard and complete your setup.
        </p>

        {error ? (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3 mb-4">
            {error}
          </div>
        ) : null}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={onChange}
              required
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring"
              placeholder="you@example.com"
              autoFocus
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Password</label>
            <input
              name="password"
              type="password"
              value={form.password}
              onChange={onChange}
              required
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl py-2.5 font-medium bg-black text-white hover:opacity-90 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div className="text-xs text-gray-500 mt-4">
          Don’t have an account?{" "}
          <a href="/signup" className="underline">
            Create an account
          </a>
        </div>

        <p className="text-xs text-gray-400 mt-2">
          By continuing you agree to our Terms of Service.
        </p>
      </div>
    </div>
  );
}
